import { ReactNode } from "react";
import styles from "./ModalColumn.module.css";

type ModalColumnProps = {
  children: ReactNode;
  gap: "small" | "medium" | "big";
  className?: string | undefined;
};

function ModalColumn({ children, gap, className }: ModalColumnProps) {
  const combinedClassName = className
    ? `${styles[gap]} ${className}`
    : styles[gap];
  return <div className={combinedClassName}>{children}</div>;
}

export default ModalColumn;
